import { render, staticRenderFns } from "./PersonalDataTeamRequired.vue?vue&type=template&id=6ca187d6&scoped=true"
import script from "./PersonalDataTeamRequired.vue?vue&type=script&lang=js"
export * from "./PersonalDataTeamRequired.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataTeamRequired.vue?vue&type=style&index=0&id=6ca187d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca187d6",
  null
  
)

export default component.exports